const spotlights = [
  {
    title: '国漫崛起：从追赶到领跑',
    desc: '国产漫画产业近年来经历了翻天覆地的变化。从《一人之下》到《镖人》，从《镇魂街》到《狐妖小红娘》，国漫以独特的中国美学和叙事风格赢得了越来越多漫友的喜爱。本期专题带你细数那些不容错过的国漫佳作。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20illustration%20of%20Chinese%20ink%20painting%20style%20comic%20panels%20with%20modern%20digital%20elements%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20dynamic%20composition%2C%20clean%20background%2C%20artistic%20flat%20design%2C%20soft%20lighting&width=900&height=400&seq=manwa-carousel-1&orientation=landscape',
  },
  {
    title: 'JUMP系连载追更全攻略',
    desc: '周刊少年JUMP作为日漫风向标，每周都有大量连载更新。海贼王最终章、咒术回战新篇章、坂本日常等热门作品追更进度实时同步。本期整理当前JUMP系连载漫画完整追更时间表，助你高效追漫。',
    tag: '追更指南',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20flat%20design%20illustration%20of%20Japanese%20manga%20magazine%20style%20with%20action%20lines%20and%20speech%20bubbles%2C%20warm%20amber%20and%20coral%20accents%2C%20energetic%20composition%2C%20clean%20background%2C%20artistic%20style&width=900&height=400&seq=manwa-carousel-2&orientation=landscape',
  },
  {
    title: '悬疑推理漫入坑指南',
    desc: '如果你喜欢烧脑剧情和意想不到的反转，悬疑推理漫画绝对不容错过。从经典本格推理到心理悬疑，从社会派到科幻推理，本期精选多部高分悬疑漫画，带你体验智商被碾压的快感。',
    tag: '入坑推荐',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20flat%20design%20illustration%20with%20silhouettes%20and%20puzzle%20elements%2C%20warm%20amber%20lighting%2C%20noir%20atmosphere%2C%20clean%20background%2C%20artistic%20comic%20style%2C%20soft%20shadows%2C%20elegant%20composition&width=900&height=400&seq=manwa-carousel-3&orientation=landscape',
  },
  {
    title: '追更新姿势大比拼',
    desc: '周更、双周更、月更、不定期更新……不同连载节奏需要不同的追更策略。追更老司机分享高效追漫心得，从追更列表管理到更新提醒设置，让你从容应对各种更新节奏，成为追更达人。',
    tag: '追更技巧',
    img: 'https://readdy.ai/api/search-image?query=Modern%20flat%20design%20illustration%20of%20organized%20digital%20devices%20showing%20manga%20tracking%20interface%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20background%2C%20tech%20friendly%2C%20artistic%20style%2C%20soft%20lighting&width=900&height=400&seq=manwa-carousel-4&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            重磅推荐
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            编辑精选的焦点专题，深入了解漫画追更世界的方方面面
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {spotlights.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group block rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="w-full aspect-[21/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-xs font-semibold text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-3">{item.tag}</span>
                <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}